module.exports = __webpack_public_path__ + "static/media/pic2.0b2e25b7.jpg";